import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { Button } from '@unite-us/ui';
import _ from 'lodash';
import OverlaySpinner from '../../../common/spinners/OverlaySpinner';
import ProfileEmailFields from '../ProfileEmailFields';
import { FACESHEET } from '../../../../constants/eventConstants';
import { cleanEmailValues } from '../../../utils/cleanContactValues';
import { emailsInitialValues } from './utils';
import './stylesheets/editEmailAddresses.scss';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import callOrLog from '../../../../constants/callOrLog';
import { trackEvent } from '../../../../config/api';
export function EditEmailAddresses(props) {
  var emailsFieldsRef = useRef();
  var onSubmit = function onSubmit(values) {
    var _context;
    var emails = _mapInstanceProperty(_context = values.emails || []).call(_context, cleanEmailValues);
    callOrLog(function () {
      return trackEvent(FACESHEET.emailUpdated);
    });
    return props.onSave(emails).then(props.closeModal);
  };
  var addField = function addField() {
    emailsFieldsRef.current.push({});
    window.dispatchEvent(new Event('resize'));
  };
  var emails = props.emails,
    styles = props.styles;
  var deletingEmail = false;
  var emailsInitial = emailsInitialValues(emails);
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
    // validate={this.validate}
    ,
    mutators: _objectSpread({}, arrayMutators),
    initialValues: {
      emails: emailsInitial
    },
    initialValuesEqual: _.isEqual,
    render: function render(_ref) {
      var handleSubmit = _ref.handleSubmit,
        submitting = _ref.submitting;
      return /*#__PURE__*/React.createElement("form", {
        className: "edit-email-addresses content-with-actions",
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement(OverlaySpinner, {
        text: "Saving...",
        show: submitting || deletingEmail
      }), /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement(FieldArray, {
        name: "emails"
      }, function (_ref2) {
        var fields = _ref2.fields;
        emailsFieldsRef.current = fields;
        return _mapInstanceProperty(fields).call(fields, function (fieldName, index) {
          return /*#__PURE__*/React.createElement("div", {
            id: "email-".concat(index),
            key: fieldName,
            style: index !== emails.length - 1 ? styles.inlineEmailContainer : {}
          }, /*#__PURE__*/React.createElement(ProfileEmailFields, {
            id: "".concat(index, "-communication-types-checkboxes"),
            fieldName: fieldName,
            onRemove: function onRemove() {
              return fields.remove(index);
            }
          }));
        });
      })), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6 text-left edit-email-addresses__add-email"
      }, /*#__PURE__*/React.createElement("button", {
        className: "text-sm",
        id: "add-email-link",
        type: "button",
        onClick: addField
      }, "+ Add Email")), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6"
      }, /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-email-cancel-btn",
        onClick: props.closeModal,
        disabled: submitting,
        label: "Cancel"
      })), /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-email-save-btn",
        disabled: submitting,
        label: "Save",
        primary: true,
        type: "submit"
      }))))));
    }
  });
}
EditEmailAddresses.propTypes = {
  closeModal: PropTypes.func,
  onSave: PropTypes.func,
  styles: PropTypes.shape({
    inlineEmailContainer: PropTypes.object
  })
};
EditEmailAddresses.defaultProps = {
  closeModal: _.noop,
  onSave: _.noop,
  styles: {
    inlineEmailContainer: {
      borderBottom: '1px solid #EBECED',
      marginBottom: '20px',
      paddingBottom: '10px'
    }
  }
};
export default EditEmailAddresses;
//# sourceMappingURL=index.js.map